<template>
  <b-badge
    v-if="rank <= 3 && type === 'winner'"
    pill
    class="d-flex align-items-center justify-content-center"
    :style="{
      width: '28px',
      height: '28px',
      fontSize: '14px',
      background: badgeColor,
    }"
    :variant="badgeColor"
  >
    {{ rank === 1 ? "🏆" : rank }}
  </b-badge>
  <b-badge
    v-else
    pill
    class="d-flex align-items-center justify-content-center"
    :style="{ width: '28px', height: '28px', fontSize: '14px' }"
    :variant="type === 'winner' ? 'success' : 'danger'"
  >
    {{ rank }}
  </b-badge>
</template>

<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  props: {
    rank: Number,
    type: String,
  },
  computed: {
    badgeColor() {
      if (this.rank === 1) return "warning";
      if (this.rank === 2) return "secondary";
      if (this.rank === 3) return "#e17100";
      return "primary";
    },
  },
};
</script>
